<markant-platform-requests-widget-v2
  widgetType="priceRequests"
  [loading]="(loading$ | async) || false"
  [title]="'platformWidget.admin.priceRequests.widgetName' | transloco"
  icon="m_euro"
  [description]="description"
  [secondSectionLabel]="
    'platformWidget.admin.priceRequests.contextData' | transloco
  "
  [inProgressRequests]="inProgressRequests"
  [openRequests]="newRequests"
  [openUpgrade]="request.upgradeOpenRequests"
  [inProgressUpgrade]="request.upgradeInProgressRequests"
  [inProgressUpgradeTooltip]="
    'platformWidget.admin.priceRequests.requestInProgress' | transloco
  "
  [openUpgradeTooltip]="
    'platformWidget.admin.priceRequests.requestOpen' | transloco
  "
></markant-platform-requests-widget-v2>
